





























































































import { Component, Vue, Watch } from "vue-property-decorator";
import { SettingsPayload, ScheduleSetting } from "@/api";

@Component
export default class ScheduleSettingsTab extends Vue {
  form: SettingsPayload = {
    MaxHourPerDay: undefined,
    MaxHourPerWeek: undefined,
  };

  saving = false;
  saved = false;

  rules = {
    positiveNumber: (v: number | undefined) =>
      !v || v > 0 || "Must be a positive number",
    maxDay: (v: number | undefined) =>
      !v || v <= 24 || "Cannot exceed 24 hours per day",
    maxWeek: (v: number | undefined) =>
      !v || v <= 168 || "Cannot exceed 168 hours per week",
  };

  get scheduleSettings(): ScheduleSetting | null {
    return this.$store.getters["schedule/scheduleSettings"];
  }

  @Watch("scheduleSettings", { immediate: true })
  onSettingsLoaded(val: ScheduleSetting | null) {
    if (val?.settings) {
      this.form = { ...val.settings };
    }
  }

  async mounted() {
    await this.$store.dispatch("schedule/fetchScheduleSettings");
  }

  async save() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const valid = (this.$refs.form as any).validate();
    if (!valid) return;

    this.saving = true;
    this.saved = false;
    try {
      await this.$store.dispatch("schedule/upsertScheduleSettings", {
        MaxHourPerDay: this.form.MaxHourPerDay || undefined,
        MaxHourPerWeek: this.form.MaxHourPerWeek || undefined,
      } as SettingsPayload);
      this.saved = true;
      setTimeout(() => {
        this.saved = false;
      }, 3000);
    } catch {
      // error surfaced via alert module
    } finally {
      this.saving = false;
    }
  }

  reset() {
    const current = this.scheduleSettings?.settings;
    this.form = current
      ? { ...current }
      : { MaxHourPerDay: undefined, MaxHourPerWeek: undefined };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (this.$refs.form as any).resetValidation();
  }
}
